import { render, staticRenderFns } from "./OfflineIcon.vue?vue&type=template&id=20a54844&scoped=true"
import script from "./OfflineIcon.vue?vue&type=script&lang=js"
export * from "./OfflineIcon.vue?vue&type=script&lang=js"
import style0 from "./OfflineIcon.vue?vue&type=style&index=0&id=20a54844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a54844",
  null
  
)

export default component.exports